export default __webpack_public_path__ + "static/media/bag-icon-purple-min.1bed24f9.png";